/**
 * Algemene vragen die op elke landelijke dienstpagina terugkomen.
 * Een selectie uit /veelgestelde-vragen, zodat Google ze ook daar in het
 * FAQPage-schema meeneemt.
 */
export const algemeneFaq: { v: string; a: string }[] = [
  {
    v: "Wat kost een elektricien per uur in 2026?",
    a: "Een zelfstandige elektricien rekent doorgaans € 55 tot € 85 per uur; grotere installatiebedrijven zitten eerder op € 75 tot € 110 per uur. Voor spoed buiten kantooruren geldt vaak een toeslag van 50 tot 100 procent. Via offerto vergelijk je de uurtarieven van meerdere elektriciens uit jouw regio naast elkaar.",
  },
  {
    v: "Hoe vind ik een betrouwbare elektricien?",
    a: "Vraag meerdere offertes aan, controleer of het bedrijf ingeschreven staat bij de Kamer van Koophandel en beschikt over de juiste certificeringen (NEN 1010, NEN 3140, Sterkin), lees recente reviews op onafhankelijke platforms en vraag om een schriftelijke offerte met een transparant uurtarief. Via offerto krijg je tot vijf offertes van bedrijven die deze controles al doorlopen zijn.",
  },
  {
    v: "Welke certificeringen zijn belangrijk bij een elektricien?",
    a: "De belangrijkste zijn NEN 1010 (veilig aanleggen en aansluiten van elektrische installaties in woningen), NEN 3140 (periodieke controle van elektrische apparatuur en gereedschap), Sterkin/REI (erkend voor het werken aan de netaansluiting), VEI (voorkeuring van installaties) en inschrijving in het TechniekRegister. VCA-gecertificeerde monteurs tonen aan dat ze veilig werken volgen.",
  },
  {
    v: "Hoeveel offertes moet ik aanvragen?",
    a: "Vraag minimaal drie offertes aan zodat je prijs, planning en voorwaarden kunt vergelijken. Via offerto deel je één aanvraag met maximaal vijf erkende elektriciens uit jouw regio, zodat je zonder extra moeite een goed beeld krijgt van de markt en zelf kiest wie je inschakelt — of niemand.",
  },
];
